var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8;
import { __awaiter, __decorate, __metadata } from "tslib";
import { Mutation, Action, VuexModule, Module } from 'vuex-module-decorators';
import axios from 'axios';
import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/finance/AssetProfillingEnums';
let AssetProfillingModule = class AssetProfillingModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.wasFirstLoad = true;
        this.loading = false;
        this.assetProfillingList = [];
        this.assetProfillingCode = [];
        this.assetProfillingDesc = [];
        this.selectedCategoryCode = [];
        this.selectedCategoryDesc = [];
        this.isActive = true;
        this.useFilter = true;
        this.assetProfillingPaging = [];
        this.loadPage = false;
        this.page = 1;
        this.size = 10;
        this.pageFilter = 1;
        this.wasLoadQuickFilter = true;
        this.desc = '';
        this.status = '';
        this.statusMessage = '';
        this.searchBy = '';
    }
    get getAssetProfillingWasFirstLoad() {
        return this.wasFirstLoad;
    }
    get getAssetProfillingLoading() {
        return this.loading;
    }
    get getAssetProfillingDataList() {
        return this.assetProfillingList;
    }
    get getAssetProfillingListCode() {
        return this.assetProfillingCode;
    }
    get getAssetProfillingListDesc() {
        return this.assetProfillingDesc;
    }
    get getAssetProfillingSelectedCode() {
        return this.selectedCategoryCode;
    }
    get getAssetProfillingSelectedDesc() {
        return this.selectedCategoryDesc;
    }
    get getAssetProfillingActive() {
        return this.isActive;
    }
    get getAssetProfillingPaging() {
        return this.assetProfillingPaging;
    }
    get getAssetProfillingSize() {
        return this.size;
    }
    get getAssetProfillingStatus() {
        const status = {
            status: this.status,
            statusMessage: this.statusMessage
        };
        return status;
    }
    get getUseFilterAssetProfilling() {
        return this.useFilter;
    }
    get getAssetProfilingWasLoadQuickFilter() {
        return this.wasLoadQuickFilter;
    }
    get getAssetProfillingDesc() {
        return this.desc;
    }
    get getAssetProfillingSearchBy() {
        return this.searchBy;
    }
    [_a = Mutations.SET_ASSET_PROFILLING_WAS_FIRST_LOAD](payload) {
        this.wasFirstLoad = payload;
    }
    [_b = Mutations.SET_ASSET_PROFILLING_LOADING](payload) {
        this.loading = payload;
    }
    [_c = Mutations.SET_ASSET_PROFILLING_HANDLE_PAGE](payload) {
        this.page = payload;
    }
    [_d = Mutations.SET_ASSET_PROFILLING_LIST](payload) {
        this.assetProfillingList = payload;
    }
    [_e = Mutations.SET_ASSET_PROFILLING_LIST_CODE](payload) {
        this.assetProfillingCode = payload;
    }
    [_f = Mutations.SET_ASSET_PROFILLING_LIST_DESC](payload) {
        this.assetProfillingDesc = payload;
    }
    [_g = Mutations.SET_SELECTED_ASSET_PROFILLING_CODE](payload) {
        this.selectedCategoryCode = payload;
    }
    [_h = Mutations.SET_SELECTED_ASSET_PROFILLING_DESC](payload) {
        this.selectedCategoryDesc = payload;
    }
    [_j = Mutations.SET_SELECTED_ASSET_PROFILLING_ACTIVE](payload) {
        this.isActive = payload;
    }
    [_k = Mutations.SET_ASSET_PROFILLING_PAGE](payload) {
        this.assetProfillingPaging = payload;
    }
    [_l = Mutations.SET_ASSET_PROFILLING_LOAD_PAGE]() {
        this.loadPage = true;
    }
    [_m = Mutations.SET_ASSET_PROFILLING_STATUS](payload) {
        this.status = payload.status;
        this.statusMessage = payload.message;
    }
    [_o = Mutations.SET_ASSET_PROFILLING_SIZE](payload) {
        this.size = payload;
    }
    [_p = Mutations.SET_ASSET_PROFILLING_USE_FILTER](payload) {
        this.useFilter = payload;
    }
    [_q = Mutations.SET_ASSET_PROFILLING_PAGE_FILTER](payload) {
        this.pageFilter = payload;
    }
    [_r = Mutations.SET_ASSET_PROFILLING_WAS_LOAD_QUICK_FILTER](payload) {
        this.wasLoadQuickFilter = payload;
    }
    [_s = Mutations.SET_ASSET_PROFILLING_SEARCH_BY](payload) {
        this.searchBy = payload;
    }
    [_t = Mutations.SET_ASSET_PROFILLING_SEARCH_KEY](payload) {
        this.desc = payload;
    }
    [_u = Actions.GET_ASSET_PROFILLING_LIST]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_ASSET_PROFILLING_LOADING, true);
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/assetprofilling`;
            const params = {
                ver: 'v1',
                Page: this.page.toString(),
                Size: this.size.toString(),
                Desc: this.desc
            };
            return new Promise((resolve, reject) => {
                ApiService.get(url, '', new URLSearchParams(params).toString())
                    .then((res) => {
                    if (res.status === 200) {
                        this.context.commit(Mutations.SET_ASSET_PROFILLING_LIST, res.data.result.content.data);
                        this.context.commit(Mutations.SET_ASSET_PROFILLING_LOAD_PAGE, true);
                        this.context.commit(Mutations.SET_ASSET_PROFILLING_PAGE, res.data.result.content.paging);
                        this.context.commit(Mutations.SET_ASSET_PROFILLING_LOADING, false);
                        resolve(true);
                    }
                    else {
                        this.context.commit(Mutations.SET_ASSET_PROFILLING_LOADING, false);
                        reject(false);
                    }
                })
                    .catch((err) => {
                    this.context.commit(Mutations.SET_ASSET_PROFILLING_LOADING, false);
                    reject(false);
                });
            });
        });
    }
    [_v = Actions.GET_ASSET_PROFILLING_LIST_CODE_DESC]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_ASSET_PROFILLING_WAS_LOAD_QUICK_FILTER, false);
            const params = {
                ver: 'v1'
            };
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/assetprofilling/filter?` +
                new URLSearchParams(params).toString();
            const paramsData = {
                Page: this.pageFilter.toString(),
                Size: '10',
                Desc: this.desc,
                SearchBy: this.searchBy,
                assetProfillingCode: [],
                assetProfillingDesc: [],
                isActive: this.isActive
            };
            const dataCode = [...this.assetProfillingCode];
            const dataDesc = [...this.assetProfillingDesc];
            return new Promise((resolve, reject) => {
                ApiService.post(url, paramsData)
                    .then((res) => {
                    if (res.status === 200) {
                        if (res.data.result.content !== null) {
                            if (res.data.result.content.paging.totalPages === this.pageFilter) {
                                this.context.commit(Mutations.SET_ASSET_PROFILLING_WAS_LOAD_QUICK_FILTER, false);
                            }
                            else {
                                this.context.commit(Mutations.SET_ASSET_PROFILLING_WAS_LOAD_QUICK_FILTER, true);
                            }
                            res.data.result.content.data.map((data) => {
                                dataCode.push({
                                    value: data.assetProfillingCode,
                                    label: data.assetProfillingCode
                                });
                                dataDesc.push({
                                    value: data.assetProfillingDesc,
                                    label: data.assetProfillingDesc
                                });
                            });
                        }
                        else {
                            this.context.commit(Mutations.SET_ASSET_PROFILLING_WAS_LOAD_QUICK_FILTER, false);
                        }
                        this.context.commit(Mutations.SET_ASSET_PROFILLING_LIST_CODE, dataCode);
                        this.context.commit(Mutations.SET_ASSET_PROFILLING_LIST_DESC, dataDesc);
                        resolve(true);
                    }
                    else {
                        this.context.commit(Mutations.SET_ASSET_PROFILLING_WAS_LOAD_QUICK_FILTER, true);
                        reject(false);
                    }
                })
                    .catch((err) => {
                    this.context.commit(Mutations.SET_ASSET_PROFILLING_WAS_LOAD_QUICK_FILTER, true);
                    reject(false);
                });
            });
        });
    }
    [_w = Actions.CREATE_ASSET_PROFILLING_LIST](data) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/assetprofilling?ver=v1`;
            return new Promise((resolve, reject) => {
                ApiService.post(url, data)
                    .then((res) => {
                    if (res) {
                        this.context.commit(Mutations.SET_ASSET_PROFILLING_LIST_CODE, []);
                        this.context.commit(Mutations.SET_ASSET_PROFILLING_LIST_DESC, []);
                        this.context.commit(Mutations.SET_ASSET_PROFILLING_PAGE_FILTER, 1);
                        this.context.dispatch(Actions.GET_ASSET_PROFILLING_LIST_CODE_DESC);
                        this.context.commit(Mutations.SET_ASSET_PROFILLING_STATUS, {
                            status: res.data.statusCode,
                            message: res.data.result.message
                        });
                        this.context.dispatch(Actions.GET_ASSET_PROFILLING_DATA);
                        resolve(true);
                    }
                    else {
                        reject(false);
                    }
                    return res;
                })
                    .catch(() => {
                    reject(false);
                });
            });
        });
    }
    [_x = Actions.UPDATE_ASSET_PROFILLING_LIST](data) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/assetprofilling?ver=v1`;
            return new Promise((resolve, reject) => {
                ApiService.post(url, data)
                    .then((res) => {
                    if (res) {
                        this.context.commit(Mutations.SET_ASSET_PROFILLING_LIST_CODE, []);
                        this.context.commit(Mutations.SET_ASSET_PROFILLING_LIST_DESC, []);
                        this.context.commit(Mutations.SET_ASSET_PROFILLING_PAGE_FILTER, 1);
                        this.context.dispatch(Actions.GET_ASSET_PROFILLING_LIST_CODE_DESC);
                        this.context.commit(Mutations.SET_ASSET_PROFILLING_STATUS, {
                            status: res.data.statusCode,
                            message: res.data.result.message
                        });
                        this.context.dispatch(Actions.GET_ASSET_PROFILLING_DATA);
                        resolve(true);
                    }
                    else {
                        reject(false);
                    }
                    return res;
                })
                    .catch(() => {
                    reject(false);
                });
            });
        });
    }
    [_y = Actions.GET_ASSET_PROFILLING_LIST_FILTER](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_SELECTED_ASSET_PROFILLING_CODE, data.assetProfillingCode);
            this.context.commit(Mutations.SET_SELECTED_ASSET_PROFILLING_DESC, data.assetProfillingDesc);
            this.context.commit(Mutations.SET_SELECTED_ASSET_PROFILLING_ACTIVE, data.isActive);
            const params = {
                ver: 'v1'
            };
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/assetprofilling/filter?` +
                new URLSearchParams(params).toString();
            const paramsData = {
                Page: this.page.toString(),
                Size: this.size.toString(),
                Desc: '',
                SearchBy: '',
                assetProfillingCode: data.assetProfillingCode,
                assetProfillingDesc: data.assetProfillingDesc,
                isActive: data.isActive
            };
            return new Promise((resolve, reject) => {
                ApiService.post(url, paramsData)
                    .then((res) => {
                    var _9, _10, _11;
                    if (res.status === 200) {
                        this.context.commit(Mutations.SET_ASSET_PROFILLING_LIST, ((_9 = res.data.result.content) === null || _9 === void 0 ? void 0 : _9.data) || []);
                        if (!this.loadPage) {
                            this.context.commit(Mutations.SET_ASSET_PROFILLING_LOAD_PAGE, true);
                            this.context.commit(Mutations.SET_ASSET_PROFILLING_PAGE, ((_10 = res.data.result.content) === null || _10 === void 0 ? void 0 : _10.paging) || {
                                currentPage: 0,
                                totalPages: 0,
                                totalElements: 0,
                                errorRows: 0,
                                readyToUpload: 0
                            });
                        }
                        this.context.commit(Mutations.SET_ASSET_PROFILLING_PAGE, ((_11 = res.data.result.content) === null || _11 === void 0 ? void 0 : _11.paging) || {
                            currentPage: 0,
                            totalPages: 0,
                            totalElements: 0,
                            errorRows: 0,
                            readyToUpload: 0
                        });
                        resolve(true);
                    }
                    else {
                        reject(false);
                    }
                })
                    .catch((err) => {
                    reject(false);
                });
            });
        });
    }
    [_z = Actions.DOWNLOAD_ASSET_PROFILLING]() {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/fincapex/api/master/assetprofilling/download?ver=v1`;
            axios({
                url: apiUrl,
                method: 'POST',
                responseType: 'blob',
                data: {
                    assetProfillingCode: this.selectedCategoryCode,
                    assetProfillingDesc: this.selectedCategoryDesc,
                    isActive: this.isActive
                }
            }).then((response) => {
                // eslint-disable-next-line comma-spacing
                const fileName = response.headers['content-disposition']
                    .split('; ')[1]
                    .split('=')[1]
                    .replaceAll('/', '-')
                    .replaceAll('"', '');
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
            });
        });
    }
    [_0 = Actions.UPDATE_ASSET_PROFILLING_PAGE_FILTER]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_ASSET_PROFILLING_PAGE_FILTER, this.pageFilter + 1);
        });
    }
    [_1 = Actions.GET_ASSET_PROFILLING_DATA]() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.useFilter) {
                this.context.dispatch(Actions.GET_ASSET_PROFILLING_LIST);
            }
            else {
                this.context.dispatch(Actions.GET_ASSET_PROFILLING_LIST_FILTER, {
                    assetProfillingCode: this.selectedCategoryCode,
                    assetProfillingDesc: this.selectedCategoryDesc,
                    isActive: this.isActive
                });
            }
        });
    }
    [_2 = Actions.UPDATE_SELECTED_ASSET_PROFILLING_CODE](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_SELECTED_ASSET_PROFILLING_CODE, data);
            this.context.commit(Mutations.SET_ASSET_PROFILLING_HANDLE_PAGE, 1);
            this.context.dispatch(Actions.GET_ASSET_PROFILLING_DATA);
        });
    }
    [_3 = Actions.UPDATE_SELECTED_ASSET_PROFILLING_DESC](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_SELECTED_ASSET_PROFILLING_DESC, data);
            this.context.commit(Mutations.SET_ASSET_PROFILLING_HANDLE_PAGE, 1);
            this.context.dispatch(Actions.GET_ASSET_PROFILLING_DATA);
        });
    }
    [_4 = Actions.UPDATE_SELECTED_ASSET_PROFILLING_ACTIVE](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_SELECTED_ASSET_PROFILLING_ACTIVE, data);
            this.context.commit(Mutations.SET_SELECTED_ASSET_PROFILLING_CODE, []);
            this.context.commit(Mutations.SET_SELECTED_ASSET_PROFILLING_DESC, []);
            this.context.commit(Mutations.SET_ASSET_PROFILLING_HANDLE_PAGE, 1);
            this.context.commit(Mutations.SET_ASSET_PROFILLING_PAGE_FILTER, 1);
            this.context.dispatch(Actions.GET_ASSET_PROFILLING_DATA);
            this.context.dispatch(Actions.GET_ASSET_PROFILLING_LIST_CODE_DESC);
        });
    }
    [_5 = Actions.UPDATE_ASSET_PROFILLING_SIZE](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_ASSET_PROFILLING_SIZE, data);
            this.context.commit(Mutations.SET_ASSET_PROFILLING_HANDLE_PAGE, 1);
            this.context.dispatch(Actions.GET_ASSET_PROFILLING_DATA);
        });
    }
    [_6 = Actions.RESET_ASSET_PROFILLING_FILTER]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_SELECTED_ASSET_PROFILLING_CODE, []);
            this.context.commit(Mutations.SET_SELECTED_ASSET_PROFILLING_DESC, []);
            this.context.commit(Mutations.SET_SELECTED_ASSET_PROFILLING_ACTIVE, true);
            this.context.commit(Mutations.SET_ASSET_PROFILLING_HANDLE_PAGE, 1);
            this.context.commit(Mutations.SET_ASSET_PROFILLING_PAGE_FILTER, 1);
            this.context.dispatch(Actions.GET_ASSET_PROFILLING_DATA);
            this.context.dispatch(Actions.GET_ASSET_PROFILLING_LIST_CODE_DESC);
        });
    }
    [_7 = Actions.UPDATE_SEARCH_ASSET_PROFILLING_DESC](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_ASSET_PROFILLING_SEARCH_BY, 'AssetProfillingDesc');
            this.context.commit(Mutations.SET_ASSET_PROFILLING_SEARCH_KEY, data);
            this.context.commit(Mutations.SET_ASSET_PROFILLING_HANDLE_PAGE, 1);
            this.context.commit(Mutations.SET_ASSET_PROFILLING_LIST_DESC, []);
            this.context.dispatch(Actions.GET_ASSET_PROFILLING_LIST_CODE_DESC);
        });
    }
    [_8 = Actions.UPDATE_SEARCH_ASSET_PROFILLING_CODE](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_ASSET_PROFILLING_SEARCH_BY, 'AssetProfillingCode');
            this.context.commit(Mutations.SET_ASSET_PROFILLING_SEARCH_KEY, data);
            this.context.commit(Mutations.SET_ASSET_PROFILLING_HANDLE_PAGE, 1);
            this.context.commit(Mutations.SET_ASSET_PROFILLING_LIST_CODE, []);
            this.context.dispatch(Actions.GET_ASSET_PROFILLING_LIST_CODE_DESC);
        });
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssetProfillingModule.prototype, _a, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssetProfillingModule.prototype, _b, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssetProfillingModule.prototype, _c, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssetProfillingModule.prototype, _d, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssetProfillingModule.prototype, _e, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssetProfillingModule.prototype, _f, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssetProfillingModule.prototype, _g, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssetProfillingModule.prototype, _h, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssetProfillingModule.prototype, _j, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssetProfillingModule.prototype, _k, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AssetProfillingModule.prototype, _l, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssetProfillingModule.prototype, _m, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssetProfillingModule.prototype, _o, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssetProfillingModule.prototype, _p, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssetProfillingModule.prototype, _q, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssetProfillingModule.prototype, _r, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssetProfillingModule.prototype, _s, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssetProfillingModule.prototype, _t, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], AssetProfillingModule.prototype, _u, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], AssetProfillingModule.prototype, _v, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], AssetProfillingModule.prototype, _w, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], AssetProfillingModule.prototype, _x, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], AssetProfillingModule.prototype, _y, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], AssetProfillingModule.prototype, _z, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], AssetProfillingModule.prototype, _0, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], AssetProfillingModule.prototype, _1, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], AssetProfillingModule.prototype, _2, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], AssetProfillingModule.prototype, _3, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], AssetProfillingModule.prototype, _4, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], AssetProfillingModule.prototype, _5, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], AssetProfillingModule.prototype, _6, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], AssetProfillingModule.prototype, _7, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], AssetProfillingModule.prototype, _8, null);
AssetProfillingModule = __decorate([
    Module
], AssetProfillingModule);
export default AssetProfillingModule;
